<template>
    <div id="obmen">
        <div class="row">
            <div class="col-xs-12">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title">Обновление каталога продукции</h4>
                        <p class="category">{{message}}</p>
                    </div>
                    <div class="card-content">
                        <div style="height: 100px;">
                            <div v-if="l"><center><span v-html="l"></span></center></div>
<!--                            <div><p></p></div>-->
                        </div>
                        <center><button v-if="!disable" class="btn btn-danger" @click="get_goods">Обновить каталог</button></center>
                        <loader v-if="loader" ></loader>

                    </div>
                </div>
            </div>
        </div>
        <div class="row" id="menu" style="position: fixed;z-index: 9990;background: rgba(4,7,6,0.27);height: 60px;bottom:0px;width: 100%;">
            <div class="col-xs-12" style=" padding-left: 4%; padding: 0px;border-top:1px ridge rgba(4,7,6,0.16);">
                <div class="col-xs-3" style="background: white;padding: 10px;">
                    <router-link to="/catalog">
                        <center>
                            <i class="ti-agenda" style="font-size: 20px;padding-top:6px;"></i>
                            <br/>
                            <span style="font-size: 1em;">Каталог</span>
                        </center>
                    </router-link>
                </div>
                <div class="col-xs-3" style="background: white;padding: 10px;">
                    <router-link to="/order">
                        <center>
                            <i class="ti-shopping-cart" style="font-size: 20px;padding-top:6px;"></i>
                            <br/>
                            <span style="font-size: 1em;">Заказ</span>
                        </center>
                    </router-link>
                </div>
                <div class="col-xs-3" style="background: white;padding: 10px;">
                    <router-link to="/orderslist">
                        <center>
                            <i class="ti-timer" style="font-size: 20px;padding-top:6px;"></i>
                            <br/>
                            <span style="font-size: 1em;">История</span>
                        </center>
                    </router-link>
                </div>
                <div class="col-xs-3" style="background: #ececec;padding: 10px;">
                    <router-link to="/settings">
                        <center>
                            <i class="ti-more-alt" style="font-size: 20px;padding-top:6px;"></i>
                            <br/>
                            <span style="font-size: 1em;">Ещё</span>
                        </center>
                    </router-link>
                </div>
                <!--                <div class="col-xs-2" style="background: white;padding: 5px;">-->
                <!--                    <center>-->
                <!--                        <i class="ti-clipboard" style="font-size: 20px;padding-top:6px;"></i>-->
                <!--                        <br/>-->
                <!--                        <span style="font-size: 1em;">Профиль</span>-->
                <!--                    </center>-->
                <!--                </div>-->
                <!--                <router-link to="/order">-->
                <!--                    <p>chno-to</p>-->
                <!--&lt;!&ndash;                    <button class="btn btn-warning btn-fill btn-wd" style="height: 60px; width: 100%;" @click=""><span class="center" style="padding-left:60px; ">Корзина</span><span class="pull-right">{{sum}} руб.</span></button>&ndash;&gt;-->
                <!--                </router-link>-->
            </div>
        </div>
    </div>
</template>

<script>

  import Loader from 'src/components/UIComponents/Custom/LoaderCustom'
  import StatsCard from '../Cards/StatsCard'


  export default {
    components: {
      Loader,
      StatsCard
    },
    name: 'Obmen',
    data () {
      return {
        l: '',
        loader: false,
        message: '',
        timerId: 0,
        settings: undefined,
        disable: false,
        distr: 0,
        token: null
      }
    },
    mounted () {
      if (localStorage.getItem('curentDist')) {
        this.distr = localStorage.getItem('curentDist')
        this.setToken()
      } else {
        this.$db.settings.toArray()
        // eslint-disable-next-line no-return-assign
          .then((x) => {
            if (x.length > 0) {
              this.distr = x[0].dbase
              this.token = x[0].token
              localStorage.curentDist = x[0].dbase
              this.setToken()
            }
          })
      }

      this.checksettings()
    },
    methods: {
      setToken () {
        this.$db.settings.where({'dbase': this.distr}).toArray()
          .then((x) => {
            this.token = x[0].token
          })
          .catch((e) => {
            console.log(e)
          })
      },
      sleep (ms) {
        return new Promise(resolve => {
          setTimeout(resolve, ms)
        })
      },
      ldt (i) {
        if (this.l.length > 200) {
          this.l = ''
        }
        this.l = this.l + '<span><i class="ti-angle-right"></i></span>'
      },
      checksettings () {
        this.$db.settings.toArray()
          .then((x) => {
            if (x.length !== 0) {
              this.settings = x[0]
              // let t = JSON.parse(this.settings.dst)
            } else {
              // console.log('А нету настроек')
              this.$router.push({ name: 'Start' })
            }
          })
          .catch((e) => {
            console.log(e)
          })
          .finally(() => {
            if (this.settings) {
              this.get_goods()
            }
            // console.log('finally')
          }
          )
      },
      get_goods () {
        // this.$db.goods.clear()
        let _this = this
        this.disable = true
        this.timerId = setInterval(() => this.ldt('ti-angle-right'), 500)
        this.message = 'Идет обновление'
        // this.checksettings()
        const axios = require('axios')
        axios({
          method: 'post',
          url: 'https://webzakaz.akitorg.ru/i.php',
          headers: {'X-User-Id': this.distr, 'X-Authorization': this.token, 'X-Route': 'get_prices'},
          data: {phone: ''}
        })
          .then((res) => {
            this.message = 'запрос выполнен'

            this.$db.settings.update(this.settings.token, {lastconnection: Date.now()})
            // console.log(res)
            if (res.status === 200) {
              let goods = res.data
              goods.forEach(function (item, i, goods) {
                let a = {}
                a = item
                a.distr = _this.distr
                goods[i] = a
                // console.log(goods[i])
              })
              // console.log(goods)
              this.$db.goods.clear()
              this.$db.goods.bulkPut(goods).then(() => {
                // console.log(Date.now())
                this.loader = false
                this.message = 'Каталог успешно обновлен'
                clearInterval(this.timerId)
                this.l = '<span style="font-size: 20px;"><i class="ti-face-smile"></i></span>'
                this.disable = false
                // window.location.reload(true)
                this.sleep(600).then(() => { this.$router.push({ path: 'catalog', query: { refresh: '1' } }) })
              })
            } else {
              this.message = res.status
            }
          })
          .catch((error) => {
            this.disable = false
            console.log(error)
            // return
            this.message = error.response.data
            if (error.response) {
              if (error.response.data === '400 Invalid phone') {
                console.log('не верный телефон')
                alert('не верный телефон')
              }
              if (error.response.data === '400 Invalid INN') {
                console.log('не верный ИНН')
                alert('не верный ИНН')
              }
              if (error.response.data === '411 Array Required') {
                console.log('не верный телефон')
                alert('не верный телефон')
              }
              if (error.response.data === '400 INN not found') {
                console.log('не верный INN')
                alert('не верный INN')
              }
              if (error.response.data === '400 Uuid already registered') {
                console.log('Что то с UUID')
                alert('Что то с UUID')
              }
            } else if (error.request) {
              // The request was made but no response was received
              console.log(error.request)
            } else {
              // Something happened in setting up the request that triggered an Error
              console.log('Error', error.message)
            }
          })
      }
    }
  }
</script>

<style scoped>
    a {
        color: #000000;
    }
    .row{
        margin: 0px;
    }
</style>


// WEBPACK FOOTER //
// src/components/UIComponents/Custom/Obmen.vue